type LogLevel = 'debug' | 'warn' | 'error' | 'info' | 'log';

const formatLogMessage = (message: unknown): string => {
    if (typeof message === 'string') {
        return message;
    }

    if (message instanceof Error) {
        return message.message || message.name;
    }

    if (typeof message === 'number' || typeof message === 'boolean' || typeof message === 'bigint') {
        return String(message);
    }

    if (message === null || message === undefined) {
        return String(message);
    }

    try {
        return JSON.stringify(message);
    } catch {
        return Object.prototype.toString.call(message);
    }
};

interface LoggerInterface {
    showLog(messageType: LogLevel, message: unknown): void;
}
// browser logger to avoid use of console.warn/console.error/console.info etc in the code.
class Logger implements LoggerInterface {
    public showLog(messageType: LogLevel, message: unknown): void {
        this.emitLogMessage(messageType, formatLogMessage(message));
    }

    private emitLogMessage = (messageType: LogLevel, message: string) => {
        console[messageType](message);
    };
}

export default new Logger();
